/* eslint-disable max-lines */
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { navigate } from '@reach/router'
import { bool, object } from 'prop-types'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import Mensagem from '../Mensagem/Mensagem'
import DesfazerCancelamento from '../DesfazerCancelamento/DesfazerCancelamento'
import { SolicitacaoCancelamentoProvider } from '../../contexts/SolicitacaoCancelamentoContext'
import { useModalidade } from '../../contexts/ModalidadeContext'
import { useGlobal } from '../../contexts/GlobalContext'
import {
  AGUARDANDO_CANCELAMENTO_STATUS,
  CONTINUE_DESCRICAO,
  CONTINUE_TITULO,
  PLANO_TITULO,
  REATIVAR_DESCRICAO,
  REATIVAR_TITULO,
  RENOVAR_PLANO_DESCRICAO,
  RENOVAR_PLANO_TITULO,
  SOLICITOU_CANCELAMENTO_STATUS,
} from './constantsInformacaoPlano'
import { STATUS_CANCELADO, URLS, VER_MAIS, EVENTOS_GA, ROUTE_BASEPATH, PLANO_MENSAL, METODO_PAGAMENTO_CARTAO } from '../../constants'
import { enviaEventoGA } from '../../utils/helpers/helpersGA'
import { isEmptyObject } from '../../utils/helpers/helpers'
import { formatValor, formataDescricaoStatus } from '../../utils/formatter/formatter'
import { URLS_APP } from '../../config'
import { getVendasPorAssinatura } from '../../api/assinatura.servico'

const ButtonWrapper= styled.div`
  max-width: 170px;
  overflow: hidden;
  position: absolute;
  right: -20px;
  top: 10px;

  a {
    @media( max-width: ${StyleGuide.mediaQuery.smallpc} ) {
      font-size: 16px;
      padding: 5px 10px 0;
    }
  }
`

const Titulo = styled.h2`
  margin: 0;
  margin-bottom: 10px;

  @media( max-width: ${StyleGuide.mediaQuery.smallpc} ) {
    font-size: 18px;
  }
`

const WrapperContent = styled.div`
  margin: 0;

  @media ( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    width: 100%;
  }

  .item__titulo {
    ${StyleGuide.tipografia.textoDefault};
    margin: 0;

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 14px
    }
  }

  .texto {
    ${StyleGuide.tipografia.textoDefault};
    line-height: 1.6;
    margin:  0 0 16px 0;

    &:last-of-type {
      margin-bottom: 0;
      white-space: nowrap;
    }

    @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
      margin: 0 5px 10px 0;
    }

    @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin: 5px 5px 5px 0;

      &:first-of-type {
        margin-top: 10px;
      }

      &:last-of-type {
        white-space: normal;
      }
    }

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 14px
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media ( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    display: block;
  }
`


const ResumoPlano = ( { dadosAssinatura, modalidadeAssinatura, resumido } ) => {
  const { modalidadeURL } = useGlobal()
  const [ mensagem, setMensagem ] = useState()
  const { fetchAssinaturaPorModalidade } = useModalidade()
  const [ oferecerCancelarSolicitacaoCancelamento, setOferecerCancelarSolicitacaoCancelamento ] = useState()
  const [ infosPagamento, setInfosPagamento ] = useState( {} )

  const handleClick = () => {
    navigate( `${modalidadeURL}/${URLS.PLANO}` )
  }

  const getInfosPagamento = async( assinaturaId ) => {
    const [ ultimaVenda ] = await getVendasPorAssinatura( assinaturaId )
    if ( ultimaVenda ) {
      const valorLiquidoSemDesconto = Number( ultimaVenda.valor_bruto ) + Number( ultimaVenda.valor_frete )
      const totalDescontos = Number( ultimaVenda.desconto_geral ) + Number( ultimaVenda.desconto_frete ) + Number( ultimaVenda.desconto_kit )
      setInfosPagamento( {
        'parcelas': ultimaVenda.parcelas,
        'valorLiquido': valorLiquidoSemDesconto - totalDescontos,
      } )
    }
  }

  useEffect( () => {
    if ( !isEmptyObject( dadosAssinatura ) && !isEmptyObject( modalidadeAssinatura ) ) {
      if ( dadosAssinatura.status === STATUS_CANCELADO ) {
        setMensagem( {
          'acao': REATIVAR_DESCRICAO,
          'click': () => {
            enviaEventoGA( EVENTOS_GA.REATIVACAO.FLUXO, EVENTOS_GA.REATIVACAO.ACOES.INIT )
            navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidadeURL}/${URLS.PLANO}/${URLS.REATIVAR_ASSINATURA_PLANO}` )
          },
          'texto': REATIVAR_TITULO
        } )
      } else if ( dadosAssinatura.status === SOLICITOU_CANCELAMENTO_STATUS || dadosAssinatura.status === AGUARDANDO_CANCELAMENTO_STATUS ) {
        setOferecerCancelarSolicitacaoCancelamento( true )
      } else if ( dadosAssinatura.controlesDaAssinatura.podeManter ) {
        setMensagem( {
          'acao': CONTINUE_TITULO,
          'click': () => navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidadeURL}/${URLS.PLANO}/continue-na-tag` ),
          'texto': CONTINUE_DESCRICAO
        } )
      } else if (
        dadosAssinatura.controlesDaAssinatura.podeRenovar &&
        !modalidadeAssinatura.temCobrancaBoletoPendente?.temCobrancaBoletoPendente &&
        !modalidadeAssinatura.temCobrancaPixPendente?.temCobrancaPixPendente
      ) {
        setMensagem( {
          'acao': RENOVAR_PLANO_TITULO,
          'click': () => {
            enviaEventoGA(
              EVENTOS_GA.RENOVACAO.FLUXO,
              EVENTOS_GA.RENOVACAO.ACOES.INIT
            )
            navigate( `${ROUTE_BASEPATH}${
              URLS_APP.BASE_PATH ? '/' : ''
            }${modalidadeURL}/${URLS.PLANO}/${
              URLS.RENOVAR_PLANO_ENTREGA
            }` )
          },
          'texto': RENOVAR_PLANO_DESCRICAO
        } )
      }
      getInfosPagamento( dadosAssinatura.id )
    }
  }, [] )

  const verifyIfHasRenovacaoAutomatica = () => {
    if ( dadosAssinatura.plano === PLANO_MENSAL.visualizacao ) {
      return false
    }
    if ( dadosAssinatura.status !== 'Ativo' ) {
      return false
    }
    if ( dadosAssinatura.pagamento.metodo !== METODO_PAGAMENTO_CARTAO.visualizacao ) {
      return false
    }
    const ultimoPedido = dadosAssinatura?.controles?.mesTagUltimoPedidoValido
    if ( !ultimoPedido ) {
      return true
    }
    const formatData = ultimoPedido.replace( '(', '' ).replace( ')', '' )
    const splitedData = formatData.split( ',' )
    if (
      splitedData[ 0 ] === '2022' &&
      ( splitedData[ 1 ] === '06' || splitedData[ 1 ] === '6' )

    ) {
      return false
    } else {
      return true
    }
  }

  const getValorTotalPlanoText = () => {
    const {
      parcelas,
      valorLiquido,
    } = infosPagamento
    if ( !valorLiquido ) {
      return ''
    }
    const valorParcelas = valorLiquido / parcelas
    const isValorPorMes = parcelas !== 1 || dadosAssinatura.plano === PLANO_MENSAL.visualizacao
    return `${parcelas} x ${formatValor( { 'valor': valorParcelas.toString() } )} ${isValorPorMes ? '/ mês' : ''}`
  }

  return (
    <Card
      className="card"
      largura="100%"
      margin="0 0 30px 0"
    >
      <>
        {oferecerCancelarSolicitacaoCancelamento ?
          <SolicitacaoCancelamentoProvider>
            <DesfazerCancelamento
              getDados={ () => fetchAssinaturaPorModalidade }
              resumido={ resumido }
              tituloModalidade={ modalidadeURL }
            />
          </SolicitacaoCancelamentoProvider> : null}

        {mensagem ?
          <Mensagem
            acao={ mensagem.acao }
            handleClick={ mensagem.click }
            resumido={ resumido }
            texto={ mensagem.texto }
          /> : null}

        {modalidadeURL ? <Titulo>{PLANO_TITULO}</Titulo> : null}

        <Wrapper>
          <WrapperContent resumido={ resumido }>
            {resumido && dadosAssinatura.plano ? (
              <p className="texto">
                {`Seu plano é ${dadosAssinatura.plano.toLowerCase()}`}
              </p>
            ) : (
              dadosAssinatura.plano && (
                <p className="texto">
                  {`${dadosAssinatura.plano}`}
                  <br />
                  {getValorTotalPlanoText()}
                </p>
              )
            )}

            {verifyIfHasRenovacaoAutomatica() ? (
              <p className="texto">
                {`Assinatura ativa com renovação automática ${dadosAssinatura.plano.toLowerCase()}`}
              </p>
            ) : (
              <p className="texto">
                {formataDescricaoStatus( dadosAssinatura.status )}
              </p>
            )}

            {!resumido && (
              <Fragment>
                {dadosAssinatura.pagamento.metodo ?
                  <Fragment>
                    <p className="item__titulo">Pagamento:</p>

                    <p className="texto">
                      {`${dadosAssinatura.pagamento.metodo}`}
                    </p>
                  </Fragment> : null}

                {dadosAssinatura.dataInicioTAG ?
                  <Fragment>
                    <p className="item__titulo">Data de inicio:</p>

                    <p className="texto">{`${dadosAssinatura.dataInicioTAG}`}</p>
                  </Fragment> : null}
              </Fragment>
            )}

          </WrapperContent>

        </Wrapper>

        {resumido ?
          <ButtonWrapper>
            <Button
              invertido
              noBackground
              onClick={ handleClick }
              testId="plano-vermais"
            >
              {VER_MAIS}
            </Button>
          </ButtonWrapper> : null}
      </>
    </Card>
  )
}

ResumoPlano.propTypes = {
  'dadosAssinatura': object.isRequired,
  'modalidadeAssinatura': object.isRequired,
  'resumido': bool
}

ResumoPlano.defaultProps = {
  'resumido': false
}

export default ResumoPlano
